module.exports = __webpack_public_path__ + "static/media/003-server.468fb425.svg";